import React, { useState, useEffect } from 'react'
import { Wrapper, ProgressBar } from '../_components'
import Axios from 'axios'
import { CircularProgress } from '@material-ui/core'

import { fetchUGhubToken, fetchJsonToken, handleAuthorize , getUserInfo } from '../_utils'


const ActionView = record => {
  return (
    <div className="flex items-center">
      <div onClick={ async() => {

      } } className="rounded bg-green-100 border border-gray-200 px-2 py-1 w-1/2 text-center text-gray-500 cursor-pointer">
        {`View`}
      </div>
    </div>
    
  )
}
const ProgressField = record => {
  return (
    <div className="flex w-full items-center justify-center">
      <ProgressBar value={record.value || 0}/>
      <div className="text-xs mx-2">
          {`${record.value}%`}
      </div>
    </div>
  )
}

export default function UgPassValidate() {
  const defaultColumns = React.useMemo( () => 
  [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "Business /Trading Name",
      accessor: "trading_name"
    },
    {
      Header: "Date Applied",
      accessor: "date_applied"
    },
    {
      Header: "Progress",
      accessor: "progress",
      Cell: ProgressField
    },
    {
      Header: "Application Details",
      accessor: "id",
      Cell: ActionView
    },

  ] )
  const [ loading, setLoading ] = React.useState( true )
  const [ fetchedToken, setToken  ] = useState( null )
  const [ accessData, setAccessData ] = useState( null )
  const [ userInfo, setUserInfo ] = useState( {} )
  const [ fetching, setFetching ] = useState( false )
  const [ signLoading, setSignLoading ] = useState( false )
  const [ signedResult, setSignedResult ] = useState( null )

  // React.useEffect( () => {
  //   if( userInfo ) {
  //     setFetching( false )
  //   }
  // }, [ userInfo ] )

  // React.useEffect( () => {
  //   if( loading ) {
  //     setFetching( true )
  //     fetchUGhubToken( async ( result ) => {
  //       if( result ) {
  //         let code = await localStorage.getItem( "code" )
  //       //   //set state token
  //         await setToken( result?.data?.access_token )
  //         //call the json
  //         await fetchJsonToken( async ( json_key ) => {
  //           //call the ugpass access token url
  //           console.log("json key ==")
  //           await handleAuthorize(code, result?.data?.access_token, json_key, async ( data ) => {
  //             await localStorage.setItem( "accessToken", JSON.stringify( data ) )
  //             await setAccessData( data )
  //             // get the user info
  //             await getUserInfo( data, async ( decoded ) => {
  //               await localStorage.setItem( "user_info", JSON.stringify( decoded ) )
  //               setUserInfo( decoded )
  //             } )
  //             await setLoading( false )
  //           }, ( error ) => {
  //               //console.log( error );
  //           } )
  //         }, error => {
  //           // console.log( error );
  //         } )
  //       }
  //     }, error => {
  //       // console.log( error );
  //       setLoading( false )
  //     }  )
  //   }
  // },[ loading ])
  useEffect( () => {
    if( loading ) {
      fetchUgpassUserDetails()
    }
  }, [ loading ])

  useEffect(() => {
    if (userInfo) {
      //console.log("userInfo has been updated:", userInfo);
    }
  }, [userInfo]);

  const handleLogin = async () => {
    //login_user
    setLoading( false )
    try {
        const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/ugpass_login`, {
            email: userInfo?.email
        } )
        if( response.data.success == true ) {

            await localStorage.setItem( "email", response.data.record.email_address )
            await localStorage.setItem( "userId", response.data.record.id )
            await localStorage.setItem( "username", response.data.record.email_address )
            await localStorage.setItem( "role", response.data.record.user_role )
            await localStorage.setItem( "domain", response.data.record.domain )

            //await setLoading( false )
    
            if( !response.data.record.login_status ) {
              await localStorage.setItem( "link", "change_password" )
            }
            else {
              if( response.data.record.user_role === "APPLICANT" ) {
                await localStorage.setItem( "link", "welcome" )
              }
              else {
                await localStorage.setItem( "link", "it_application" )
              }
            }

            return window.location.reload()

          } else{
            alert("The credentials do not seem correct. Please try again")
            await localStorage.clear()
            await setLoading( false )
          }
    } catch (error) {
        await localStorage.clear()
        await setLoading( false )
        alert( "Your User Credentials may not correct." )
    }
  }

  const fetchUgpassUserDetails = async () => {
    let state = await localStorage.getItem( "state" )
    try {
      const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/ugpass_info`, {state: state} )
      //console.log("fetching use info below for state: "+state) 
      
      if( response.data.user_info ) {
        await setLoading( false )
        await localStorage.setItem( "user_info", response.data.user_info )
        let returned_info = response.data.user_info
        console.log("====")
        //console.log(response.data.user_info )
        setUserInfo( returned_info )
        console.log("user info data from ugpass")
        //console.log(userInfo)
        //console.log("====")
        //console.log(typeof response.data.user_info)
        //console.log("up up up")
        // await localStorage.setItem( "email", response.data.record.email_address )
        // await localStorage.setItem( "userId", response.data.record.id )
        // await localStorage.setItem( "username", response.data.record.email_address )
        // await localStorage.setItem( "role", response.data.record.user_role )
        // await localStorage.setItem( "domain", response.data.record.domain )
      }
    }catch (error) {
        alert( "Server error occured." )
        //console.log("John Snow")
        console.log(error)
        setLoading( false )
    }
  }

  if( loading ) {
    return (
      <Wrapper> 
          <div className="flex items-center justify-center p-10 bg-green-700 text-white text-base">
            {`Loading Configuration Keys...`}
          </div>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <div className="flex items-center justify-center p-10 bg-green-700 text-white text-base">
        {`You are welcome ${userInfo.name}, You have successfully login into the IT Certification Application.`}
      </div>


      {fetching ? (
        <div className="mx-2 p-2">
          <CircularProgress size={24} color="primary"/>
        </div>
      ) : ( 
      <></> ) }

      {userInfo && 
        <div className="w-full my-2 flex flex-col rounded bg-gray-100 shadow-md px-5">
          <div className="h-8 bg-black text-white flex items-center p-5">
            {`Your User Information`}
          </div>
          <div className="flex-grow h-52 bg-white p-3 grid grid-cols-3 gap-2">
            <ItemDetail label="Name" value={userInfo?.name} />
            <ItemDetail label="Phone" value={userInfo?.phone} />
            <ItemDetail lower label="Email Address" value={userInfo?.email} />
            <ItemDetail label="Gender" value={userInfo?.gender} />
            <ItemDetail label="Country" value={userInfo?.country} />
            <ItemDetail label="ID Document Number" value={userInfo?.id_document_number} />
          </div>
        </div>}



      <div className="w-full my-2 flex flex-col rounded bg-gray-100 shadow-md px-5">
        <div className="flex-grow h-52 bg-white p-3 grid grid-rows-2 gap-2">
          <div className="my-2 flex items-center justify-between">
            <button className="bg-red-500 bg-blue-500 px-2 py-1 text-white" type="button" onClick={handleLogin}>
              {`Proceed to Applications`}
            </button>
          </div>
        </div>
      </div>

    </Wrapper>
  )
}

const CardPanel = ( { label, icon } ) => {
  return (
    <div className="cursor-pointer flex items-center justify-center items-center h-24 my-2 md:my-0 lg:my-0 md:h-36 lg:h-36 flex rounded-xl bg-[#AFC836] shadow-md">
      <div className="h-28 w-1/4 flex items-center justify-end">
        <div className="rounded-full bg-black h-3/4 w-20 flex items-center justify-center">
          {icon}
        </div>
      </div>
      <div className="flex-grow mx-2">
        <div>
          <span className="text-black font-bold text-sm">{label}</span>
        </div>
      </div>
    </div>
  )
}

const ItemDetail = ( { label, value, lower } ) => {
  return (
    <div className="flex flex-col">
      <div className="w-32">
        <h2 className="font-bold text-base">
          {`${label}:`}
        </h2>
      </div>
      <p className={`text-base ${ lower ? "lowercase" : "uppercase"}`}>
        {value}
      </p>
    </div>
  )
}
